import { render } from "./Skalatonloader.vue?vue&type=template&id=d581cfc0&scoped=true"
const script = {}

import "./Skalatonloader.vue?vue&type=style&index=0&id=d581cfc0&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d581cfc0"]])

export default __exports__